import ChecklistIcon from "@mui/icons-material/ChecklistRounded";
import type { SvgIconProps } from "@mui/material";
import CubeIcon from "@entrilia/shared/icons/CubeIcon";
import DocumentIcon from "@entrilia/shared/icons/DocumentIcon";
import type { ObjectFeature } from "../../../api/types/objectTypes";
import DatabaseIcon from "@entrilia/shared/icons/DatabaseIcon";
import FileAccessIcon from "@entrilia/shared/icons/FileAccessIcon";
import FilesIcon from "@entrilia/shared/icons/FilesIcon";
import NoteIcon from "@entrilia/shared/icons/NoteIcon";
import PortfolioMonitoringIcon from "./PortfolioMonitoringIcon";

interface Props extends SvgIconProps {
  objectFeature: ObjectFeature;
}

const ObjectFeatureIcon = ({ objectFeature, ...iconProps }: Props) => {
  switch (objectFeature) {
    case "Checklists": {
      return <ChecklistIcon {...iconProps} />;
    }
    case "Notes": {
      return <NoteIcon {...iconProps} />;
    }
    case "Files": {
      return <FilesIcon {...iconProps} />;
    }
    case "PortfolioMetrics": {
      return <PortfolioMonitoringIcon {...iconProps} />;
    }
    case "DataImport": {
      return <DatabaseIcon {...iconProps} />;
    }
    case "Contacts": {
      return <FileAccessIcon {...iconProps} />;
    }
    case "InternalUserPermissions": {
      return <FileAccessIcon {...iconProps} />;
    }
    case "CardFilePreview": {
      return <DocumentIcon {...iconProps} />;
    }
    default: {
      return <CubeIcon {...iconProps} />;
    }
  }
};

export default ObjectFeatureIcon;
